<h1>
  <div>
    <div class="icon">
      <img [src]="'assets/categories/'+typeConfig?.iconName" [alt]="typeConfig?.name + ' Icon'"/>
    </div>
    {{typeConfig?.name}}
  </div>
</h1>
